import { render, staticRenderFns } from "./officeSuppliesPurchaseAction.vue?vue&type=template&id=210a4f88&scoped=true"
import script from "./officeSuppliesPurchaseAction.vue?vue&type=script&lang=js"
export * from "./officeSuppliesPurchaseAction.vue?vue&type=script&lang=js"
import style0 from "./officeSuppliesPurchaseAction.vue?vue&type=style&index=0&id=210a4f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a4f88",
  null
  
)

export default component.exports